import {
  AtSymbolIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { StateSignin, sendResetEmail } from "lib/actions";
import { showToast } from "./components/common";

export default function FormReset() {
  const [emailSent, setEmailSent] = useState(null);

  const [responseData, setResponseData] = useState<StateSignin>();
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false);
  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const formData = new FormData(event.currentTarget as HTMLFormElement);
    try {
      setBtnSubmitDisabled(true);
      setResponseData({});
      const response = await sendResetEmail(formData);
      setResponseData(response);
      if (!response.message) {
        setEmailSent(formData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setBtnSubmitDisabled(false);
    }
  }
  async function resentEmail() {
    const response = await sendResetEmail(emailSent);
    if (!response.message) {
      showToast(0, "Email has been resent");
    }
  }
  return (
    <form className="space-y-3" onSubmit={handleSubmit}>
      <div className="flex-1 rounded-3xl shadow-lg border bg-gray-50 px-6 pb-4 pt-8">
        {!emailSent && (
          <>
            <div
              className="text-center flex items-center justify-center gap-1"
              style={{ fontSize: "20px", fontWeight: "600" }}
            >
              Reset Your Password
            </div>
            <div className="w-full">
              <div>
                <label
                  className="mb-6 mt-5 block text-xs font-medium text-gray-900"
                  htmlFor="email"
                >
                  Please enter your email to reset your password.
                </label>
                <div className="relative">
                  <input
                    className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    aria-describedby="email-error"
                  />
                  <AtSymbolIcon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
                </div>
                <div id="email-error" aria-live="polite" aria-atomic="true">
                  {responseData?.errors?.email &&
                    responseData.errors.email.map((error: string) => (
                      <p className="mt-2 text-sm text-red-500" key={error}>
                        {error}
                      </p>
                    ))}
                </div>
              </div>
            </div>
            <button
              className="mt-6 w-full flex h-10 items-center rounded-lg bg-blue-500 px-4 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
              type="submit"
              aria-disabled={btnSubmitDisabled}
            >
              Reset via Email
              <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />
            </button>
            {responseData?.message && (
              <div
                className="flex h-8 items-end space-x-1"
                aria-live="polite"
                aria-atomic="true"
              >
                <>
                  <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
                  <p className="text-sm text-red-500">{responseData.message}</p>
                </>
              </div>
            )}
          </>
        )}
        {emailSent && (
          <>
            <div
              className="text-center flex items-center justify-center gap-1"
              style={{ fontSize: "20px", fontWeight: "600" }}
            >
              We've sent you a reset link
            </div>
            <div className="w-full">
              <div>
                <label
                  className="mb-6 mt-5 block text-xs font-medium text-gray-900"
                  htmlFor="email"
                >
                  Check your inbox at {emailSent.get("email")} Remember to check
                  your spam folder if you don't see it.
                </label>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                border: "1px solid #E1E1E1",
                height: "1px",
              }}
            />
            <div
              className="h-8 "
              style={{
                fontSize: "14px",
                fontWeight: "600",

                alignContent: "end",
                textAlign: "center",
              }}
            >
              <span>Didn't get it?</span>
              <span
                style={{
                  cursor: "pointer",
                  color: "#3E83F6",
                  marginLeft: "6px",
                }}
                onClick={resentEmail}
              >
                Send again
              </span>
            </div>
          </>
        )}
      </div>
    </form>
  );
}
